// Chart colours come from CSS tokens (TradingView's own chart palette), so every
// chart in the app looks like a TradingView chart and follows the theme.
export function css(name: string, fallback: string): string {
  if (typeof window === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

export interface ChartColors {
  bg: string;
  text: string;
  grid: string;
  border: string;
  up: string;
  down: string;
  volUp: string;
  volDown: string;
  accent: string;
  warn: string;
  crosshair: string;
  label: string;
  faint: string;
}

export function chartColors(): ChartColors {
  return {
    bg: css("--chart-bg", "#000000"),
    text: css("--chart-text", "#b2b5be"),
    grid: css("--chart-grid", "rgba(255,255,255,0.045)"),
    border: css("--chart-border", "#2a2e39"),
    up: css("--chart-up", "#089981"),
    down: css("--chart-down", "#f23645"),
    volUp: css("--chart-vol-up", "rgba(38,166,154,0.5)"),
    volDown: css("--chart-vol-down", "rgba(239,83,80,0.5)"),
    accent: css("--chart-accent", "#2962ff"),
    warn: css("--warn", "#f5a524"),
    crosshair: css("--chart-crosshair", "#9598a1"),
    label: css("--chart-label", "#363a45"),
    faint: css("--faint", "#5d6678"),
  };
}

/** TradingView's chart font stack. */
export const CHART_FONT = '-apple-system, BlinkMacSystemFont, "Trebuchet MS", Roboto, Ubuntu, sans-serif';

/** Distinct, readable series colours (both themes). */
export const PALETTE = [
  "#2962ff", "#ff9800", "#ab47bc", "#00bcd4", "#e91e63", "#8bc34a",
  "#ff5722", "#42a5f5", "#ce93d8", "#26a69a", "#fdd835", "#90a4ae",
];

export function withAlpha(hex: string, alpha: number): string {
  if (hex.startsWith("rgba") || hex.startsWith("rgb")) return hex;
  const h = hex.replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
